import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase/IconBase'

function Location({
  fill = 'none',
  color = 'icon.primary',
  strokeWidth,
  ...props
}) {
  return (
    <IconBase viewBox='0 0 12 16' {...props}>
      <Path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M6 14.6693C6 14.6693 1 10.41 1 6.52112C1 3.65742 3.23857 1.33594 6 1.33594C8.76143
         1.33594 11 3.65742 11 6.52112C11 10.41 6 14.6693 6 14.6693Z'
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
        fill={fill}
      />
      <Path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M6.00521 8.41667C4.85451 8.41667 3.92188 7.48403 3.92188 6.33333C3.92188 5.18264 4.85451
         4.25 6.00521 4.25C7.1559 4.25 8.08854 5.18264 8.08854 6.33333C8.08854 7.48403 7.1559 8.41667 6.00521 8.41667Z'
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
        fill={fill}
      />
    </IconBase>
  )
}

Location.propTypes = {
  color: PropTypes.string,
  strokeWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  fill: PropTypes.string,
}

export default Location
